const DEFAULT_API_BASE_URL = 'https://api.project-tracker.de.energy';

const normalizeBaseUrl = (baseUrl) => baseUrl.replace(/\/+$/, '');

export const API_BASE_URL = normalizeBaseUrl(
  process.env.REACT_APP_API_BASE_URL || DEFAULT_API_BASE_URL,
);

export const buildApiUrl = (path = '') => {
  if (!path) {
    return API_BASE_URL;
  }

  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE_URL}${normalizedPath}`;
};

export { DEFAULT_API_BASE_URL };
